/* Riva home v2 - hero slides, draggable snap carousels, tabs.
   Works with the riva-home-* sections; every hook is a data-rvh-* attribute. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero: fading slides. A progress line under the copy fills over the slide
     duration and advances the slide when it ends. It keeps running on hover;
     only keyboard focus inside the hero pauses it.
     Arrows step manually. Without autoplay the line shows position instead. */
  function initHero(root) {
    if (root.dataset.rvhReady) return;
    root.dataset.rvhReady = '1';
    var slides = root.querySelectorAll('[data-rvh-slide]');
    if (slides.length < 2) return;
    var fill = root.querySelector('[data-rvh-progress]');
    var prev = root.querySelector('[data-rvh-hero-prev]');
    var next = root.querySelector('[data-rvh-hero-next]');
    var index = 0;
    var delay = parseInt(root.getAttribute('data-rvh-autoplay') || '0', 10) * 1000;
    var auto = delay > 0 && !reduceMotion && !(window.Shopify && Shopify.designMode);

    function runProgress() {
      if (!fill) return;
      if (!auto) {
        fill.style.animation = 'none';
        fill.style.width = ((index + 1) / slides.length * 100) + '%';
        return;
      }
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = 'rvh-progress ' + delay + 'ms linear forwards';
    }
    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
        var img = s.querySelector('img[loading="lazy"]');
        if (on && img) img.loading = 'eager';
      });
      root.classList.toggle('is-light-active', slides[index].classList.contains('is-light'));
      runProgress();
    }
    function pause(on) { if (fill) fill.style.animationPlayState = on ? 'paused' : 'running'; }

    if (fill) fill.addEventListener('animationend', function () { show(index + 1); });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    root.addEventListener('focusin', function () { pause(true); });
    root.addEventListener('focusout', function () { pause(false); });
    root.addEventListener('rvh:select', function (e) { auto = false; show(e.detail); });
    show(0);
  }

  /* Carousel: snap track that can be dragged with the mouse (touch swipes
     natively), optional arrow buttons that step by roughly one view, and an
     optional scrollbar line whose thumb shows position and can be dragged. */
  function initCarousel(root) {
    if (root.dataset.rvhReady) return;
    root.dataset.rvhReady = '1';
    var track = root.querySelector('[data-rvh-track]');
    var prev = root.querySelector('[data-rvh-prev]');
    var next = root.querySelector('[data-rvh-next]');
    var arrows = root.querySelector('.rvh-arrows');
    var bar = root.querySelector('[data-rvh-scrollbar]');
    var thumb = bar && bar.firstElementChild;
    if (!track) return;

    function unit() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.offsetWidth + gap;
    }
    function step() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap) || 0;
      var view = track.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var first = track.children[0];
      if (!first) return view;
      return Math.max(1, Math.floor((view + gap) / (first.offsetWidth + gap))) * (first.offsetWidth + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (arrows) arrows.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        bar.hidden = max <= 2;
        var ratio = track.clientWidth / track.scrollWidth;
        var progress = max > 0 ? track.scrollLeft / max : 0;
        thumb.style.width = (ratio * 100) + '%';
        thumb.style.transform = 'translateX(' + (progress * (1 / ratio - 1) * 100) + '%)';
      }
    }
    /* After a free drag, glide to the nearest card, then hand back to snapping. */
    function settle() {
      var u = unit();
      var max = track.scrollWidth - track.clientWidth;
      var target = Math.min(max, Math.round(track.scrollLeft / u) * u);
      track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      setTimeout(function () { track.classList.remove('is-dragging'); }, reduceMotion ? 0 : 400);
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });

    /* Mouse drag on the row. A drag past 5px swallows the click that follows,
       so letting go over a card does not open it. */
    var drag = null;
    var swallowClick = false;
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return;
        drag.moved = true;
        track.classList.add('is-dragging');
      }
      track.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      if (!moved) return;
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 0);
      settle();
    });
    track.addEventListener('click', function (e) {
      if (!swallowClick) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* Scrollbar: press anywhere to jump, then drag the thumb. */
    if (bar) {
      var barDrag = false;
      function seek(clientX) {
        var rect = bar.getBoundingClientRect();
        var ratio = track.clientWidth / track.scrollWidth;
        var thumbW = rect.width * ratio;
        var p = (clientX - rect.left - thumbW / 2) / Math.max(1, rect.width - thumbW);
        track.scrollLeft = Math.max(0, Math.min(1, p)) * (track.scrollWidth - track.clientWidth);
      }
      bar.addEventListener('pointerdown', function (e) {
        barDrag = true;
        bar.setPointerCapture(e.pointerId);
        bar.classList.add('is-dragging');
        track.classList.add('is-dragging');
        seek(e.clientX);
      });
      bar.addEventListener('pointermove', function (e) { if (barDrag) seek(e.clientX); });
      function endBar() {
        if (!barDrag) return;
        barDrag = false;
        bar.classList.remove('is-dragging');
        settle();
      }
      bar.addEventListener('pointerup', endBar);
      bar.addEventListener('pointercancel', endBar);
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Tabs: ARIA tablist with arrow-key support. */
  function initTabs(root) {
    if (root.dataset.rvhReady) return;
    root.dataset.rvhReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        select(tabs[(i + dir + tabs.length) % tabs.length], true);
      });
    });
  }

  /* Reviews wall: "Show more" reveals the hidden cards and removes itself. */
  function initRevwall(root) {
    if (root.dataset.rvhReady) return;
    root.dataset.rvhReady = '1';
    var more = root.querySelector('[data-rvh-revwall-more]');
    if (!more) return;
    more.addEventListener('click', function () {
      root.querySelectorAll('.rvh-revcard.is-hidden').forEach(function (c) { c.classList.remove('is-hidden'); });
      more.parentNode.remove();
    });
  }

  /* Collection Filter & sort drawer: open/close, Esc, focus return, scroll lock. */
  function initFilters(btn) {
    if (btn.dataset.rvhReady) return;
    btn.dataset.rvhReady = '1';
    var drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;
    function open() {
      drawer.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('rvc-lock');
      var first = drawer.querySelector('input, button, select, a');
      if (first) first.focus({ preventScroll: true });
    }
    function close() {
      drawer.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('rvc-lock');
      btn.focus({ preventScroll: true });
    }
    btn.addEventListener('click', open);
    drawer.querySelectorAll('[data-rvc-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rvh-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-rvh-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-rvh-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-rvc-open]').forEach(initFilters);
    (scope || document).querySelectorAll('[data-rvh-revwall]').forEach(initRevwall);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor: re-init re-rendered sections, jump to the selected slide. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-rvh-slide]');
    var hero = slide && slide.closest('[data-rvh-hero]');
    if (!hero) return;
    var n = Array.prototype.indexOf.call(hero.querySelectorAll('[data-rvh-slide]'), slide);
    hero.dispatchEvent(new CustomEvent('rvh:select', { detail: n }));
  });
})();
